/**
 * Haptic Feedback Utility
 * No-op on web, only works on native platforms with Capacitor
 */

// These are no-op functions for web
// On native apps with Capacitor, you would implement actual haptics
export async function hapticSelection() {
  // No-op on web
}

export async function hapticImpact(style = 'light') {
  // No-op on web
}

export async function hapticNotification(type = 'success') {
  // No-op on web
}

export default { hapticSelection, hapticImpact, hapticNotification };
